import AddToHomeScreenIcon from "@material-ui/icons/AddToHomeScreen";
import { token } from "functions/Helper";
import ChangeSequenceOnlineBookingHomeContent from "views/OnlineBookingHomeContent/ChangeSequenceOnlineHomeContent";
import CreateOnlineBookingHomeContent from "views/OnlineBookingHomeContent/CreateOnlineBookingHomeContent";
import DeleteOnlineBookingHomeContent from "views/OnlineBookingHomeContent/DeleteOnlineBookingHomeContent";
import EditOnlineBookingHomeContent from "views/OnlineBookingHomeContent/EditOnlineBookingHomeContent";
import OnlineBookingHomeContentList from "views/OnlineBookingHomeContent/OnlineBookingHomeContentList";
import RemoveOnlineBookingHomeContentBanner from "views/OnlineBookingHomeContent/RemoveOnlineBookingHomeContentBanner";
import UploadOnlineBookingHomeContent from "views/OnlineBookingHomeContent/UploadOnlineBookingHomeContent";
import ViewOnlineBookingHomeContent from "views/OnlineBookingHomeContent/ViewOnlineBookingHomeContent";

const onlineBookingHomeContent = () => {
  let views = [];

  if (
    token["booking.online_booking_home_content.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/OnlineBookingHomeContentList",
      name: "Online Booking Home Contents",
      icon: AddToHomeScreenIcon,
      component: OnlineBookingHomeContentList,
      layout: "/admin"
    });
  }
  return views;
};

const onlineBookingHomeContentHidden = () => {
  let views = [];
  if (
    token["booking.online_booking_home_content.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/OnlineBookingHomeContent/Create",
        name: "Create Online Booking Home Content",
        component: CreateOnlineBookingHomeContent,
        layout: "/admin"
      },
      {
        path: "/OnlineBookingHomeContent/Edit",
        name: "Edit Online Booking Home Content",
        component: EditOnlineBookingHomeContent,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/OnlineBookingHomeContent/Delete",
        name: "Delete Online Booking Home Content",
        component: DeleteOnlineBookingHomeContent,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/OnlineBookingHomeContent/ChangeSequence",
        name: "Change Online Booking Home Content Sequence",
        component: ChangeSequenceOnlineBookingHomeContent,
        layout: "/admin"
      }
    ]);
  }

  if (
    token["booking.online_booking_home_content.read"] === "allowed" ||
    token.is_admin
  ) {
    views.push({
      path: "/OnlineBookingHomeContent/View",
      name: "View Online Booking Home Content",
      component: ViewOnlineBookingHomeContent,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }

  if (
    token["booking.online_booking_home_content.write"] === "allowed" ||
    token.is_super_admin === "True"
  )
    views.push({
      path: "/OnlineBookingHomeContent/UploadBanner",
      name: "Upload Online Booking Home Content Banner",
      component: UploadOnlineBookingHomeContent,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });

  if (
    token["booking.online_booking_home_content.write"] === "allowed" ||
    token.is_super_admin === "True"
  )
    views.push({
      path: "/OnlineBookingHomeContent/RemoveBannerFile",
      name: "Remove Online Booking Home Content Banner",
      component: RemoveOnlineBookingHomeContentBanner,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  return [
    {
      collapse: true,
      name: "Online Booking Home Content Hidden",
      state: "onlineHomeContentHidden",
      hideInSidebar: true,
      views: views
    }
  ];
};

export { onlineBookingHomeContent, onlineBookingHomeContentHidden };
